// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"794":"f7fc0cb2","930":"afb5bdcc","947":"e5a69624"}[chunkId] + ".chunk.js";
};